import "../css/mycompanies.css";
import "../css/button.css";
import buttoncss from "../css/button.module.css";
import commoncss from "../css/common.module.css";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";

import { GetAllCompany } from "../../WorkSpace/Components/ApiServices/apiHandler";
import StatusIndicator from "../elements/StatusIndicator";
import { Button } from "../elements/Button";
import { ReactComponent as FilterIcon } from "../assets/icons/filter.svg";
import { ReactComponent as LeftIcon } from "../assets/icons/left_arrow.svg";
import { ReactComponent as SortIcon } from "../assets/icons/sort.svg";
import { ReactComponent as SearchIcon } from "../assets/icons/search.svg";
import { ReactComponent as DocIcon } from "../assets/icons/doc.svg";
import { ReactComponent as ConnectorIcon } from "../assets/icons/connector.svg";
import { ReactComponent as EditIcon } from "../assets/icons/edit.svg";
import { ReactComponent as CloseIcon } from "../assets/icons/close.svg";
import { ReactComponent as CreateCompanyCard } from "../assets/icons/createcompany.svg";
import { ReactComponent as DefaultCompanyIcon } from "../assets/icons/default_company.svg";
import CompanyCard, { CurrencyWatermark } from "../elements/CompanyCard";
import Tabs from "../elements/Tabs";
import InputGroup from "../elements/InputGroup";
import Dropdown from "../elements/Dropdown";
import ToggleButton from "../elements/ToggleButton";
import erps from "../data/erps.json";
import AddEditCompanyModal from "./../components/mycompanies/AddEditCompanyModal";
import SuccessModal from "../components/connections/SuccessModal";
import ErrorModal from "../components/connections/ErrorModal";
import { headers } from "../../Bookclosure/Services/ApiHandler";

export default function MyCompanies() {
  // Use the same per-environment backend as axios.defaults.baseURL (App.js)
  const domain = (process.env.REACT_APP_WEB_URL || "").replace(/\/+$/, "");

  const user = JSON.parse(localStorage.getItem("user"));
  const permissions = JSON.parse(localStorage.getItem("permission"));

  const userid = user._id;

  const [companies, setCompanies] = useState([]);
  const [companyInfo, setCompanyInfo] = useState(null);
  const [erpConnectionInfo, setErpConnectionInfo] = useState(null);
  const [companyErp, setCompanyErp] = useState(null);
  const [addERPModal, setAddERPModal] = useState(false);
  const [displayModal, setDisplayModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [linkErpBtn, setLinkErpBtn] = useState(false);
  const [companyId, setCompanyId] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const [erpLinkId, setErpLinkId] = useState(null);
  const [linkStatus, setLinkStatus] = useState({
    msbc: false,
    tally_prime: false,
  });
  const [selectedERP, setSelectedERP] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [connectionType, setConnectionType] = useState(null);
  const [oAuthUrl, setOAuthUrl] = useState(null);
  const [apiBaseUrl, setApiBaseUrl] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [grantType, setGrantType] = useState(null);
  const [scope, setScope] = useState(null);
  const [tentId, setTentId] = useState(null);
  const [erpTabs, setErpTabs] = useState([]);

  useEffect(() => {
    getCompanies();
  }, []);
  useEffect(() => {
    if (selectedERP === "DynamicBC") {
      setErpTabs(["MSBC"]);
      setActiveTab("MSBC");
    }
    if (selectedERP === "tallyPrime") {
      setErpTabs(["Tally Prime"]);
      setActiveTab("Tally Prime");
    }
  }, [selectedERP]);

  const handleClose = () => {
    setDisplayModal(false);
  };

  const fetchCompanies = () => {
    getCompanies();
  };

  const getCompanies = () => {
    GetAllCompany()
      .then((response) => {
        setCompanies(response.data.getAllCompanyData);
      })
      .catch((error) => {
        console.error("Error fetching companies:", error);
      });
  };

  // let tabs = ["MSBC", "Tally Prime", "Tally9"];
  const showERPConnections = (company) => {
    const payload = { companyId: company._id };
    axios
      .post(domain + "/api/v1/erp/get-erp-companyconfig", payload, { headers })
      .then((resp) => {
        if (resp.data.statusCode === 0) {
          const erpConfig = resp.data.erpConfig;
          if (erpConfig) {
            if (erpConfig.erp === "tallyPrime") {
              setActiveTab(["Tally Prime"]);
              setErpTabs(["Tally Prime"]);
              setCompanyErp("tallyPrime");
            } else if (erpConfig.erp === "DynamicBC") {
              setActiveTab(["MSBC"]);
              setErpTabs(["MSBC"]);
              setCompanyErp("DynamicBC");
            }
            setLinkErpBtn(false);

            const isActive = erpConfig.status === "A";

            setLinkStatus((prev) => ({
              ...prev,
              [erpConfig.companyErp]: isActive,
            }));

            setErpLinkId(erpConfig._id);
            setSelectedERP(erpConfig.erp);
            setCompanyName(erpConfig.company);
            setConnectionType(erpConfig.connection_type);
            setOAuthUrl(erpConfig.OauthUrl);
            setApiBaseUrl(erpConfig.api_url_base_path);
            setClientId(erpConfig.client_id);
            setClientSecret(erpConfig.client_secret);
            setGrantType(erpConfig.grant_type);
            setScope(erpConfig.scope);
            setTentId(erpConfig.tentId);
            setCompanyId(erpConfig.companyId);
          } else {
            setLinkErpBtn(true);
          }
        }
      })
      .catch((error) => {
        console.error("Error in getting ERP Config:", error);
      });
    // if (company.company_name === "Cronus") {
    //   // setCompanyErp("MSBC");
    //   setErpConnectionInfo(company);
    // } else if (company.company_name === "Sama Logistics Pvt Ltd.") {
    //   // setCompanyErp("Tally Prime");
    //   setErpConnectionInfo(company);
    // } else {
    setCompanyErp(null);
    setErpConnectionInfo(company);
    // }
  };

  const handleLinkStatus = (newState, id) => {
    setLinkStatus((prev) => ({
      ...prev,
      [id]: newState,
    }));
    console.log(`Toggle ${id} is now ${newState ? "ON" : "OFF"}`);
  };
  const updateErpConfigData = () => {
    // const status = linkStatus[selectedERP] || false;

    const erpData = {
      erpLinkId: erpLinkId,
      userId: userid,
      companyId: companyInfo._id,
      erp: selectedERP,
      company: companyName ? companyName : "",
      connection_type: "OAuth",
      OauthUrl: oAuthUrl ? oAuthUrl : "",
      api_url_base_path: apiBaseUrl ? apiBaseUrl : "",
      tentId: tentId ? tentId : "",
      client_id: clientId ? clientId : "",
      client_secret: clientSecret ? clientSecret : "",
      scope: scope ? scope : "",
      grant_type: "client_credentials",
      status: "A",
    };

    const payload = erpData;
    axios
      .post(domain + "/api/v1/erp/edit-erp-companyconfig", payload, { headers })
      .then((resp) => {
        console.log(resp, resp.statusCode);
        if (resp.data.statusCode === 0) {
          setSuccessMessage(resp.data.message);
          setDisplayModal(true);
          setSuccessModal(true);
          showERPConnections(companyInfo);
          setErpConnectionInfo(false);
          setLinkStatus({ msbc: false, tally_prime: false });
        } else {
          setErrorMessage(resp.data.message);
          setDisplayModal(true);
          setErrorModal(true);
          // showERPConnections(companyInfo);
          // setErpConnectionInfo(false);
          // setLinkStatus({msbc:false,tally_prime:false})
        }
      })
      .catch((error) => {
        console.error("Error in updating ERP Link:", error);
      });
  };

  const routerHistory = useHistory();
  const handleClick = (Link) => {
    routerHistory.push(Link);
  };

  console.log("companies :: ", companies);

  return (
    <div className="connections-wrapper">
      <motion.div
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: 100, opacity: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        <header className="connections-header">
          <span className="header-title">My Companies</span>
          <div className="button-group"></div>
          {/* <div className="header-actions">
            <SearchIcon />
            &ensp;&nbsp;
            <SortIcon width={40} />
            &ensp;&nbsp;
            <FilterIcon />
          </div> */}
        </header>
      </motion.div>

      <div
        className="flex-container"
        style={{ height: "-webkit-fill-available" }}
      >
        <div
          className={`${
            companyInfo != null ? "min-companies-content" : "companies-content"
          }`}
        >
          <div
            className={`${
              companyInfo != null
                ? "edit-companies-card-grid"
                : "companies-card-grid"
            }`}
          >
            <CreateCompanyCard
              style={{ width: "22.5vw", height: "94px" }}
              onClick={() => {
                if (
                  user.responsibilities === "approver" ||
                  user.responsibilities === "view"
                ) {
                  swal(
                    "Warning",
                    "You Don't have Access to Create Company ",
                    "warning"
                  );
                } else if (
                  permissions?.unrestrictedAcessData[0]?.permission?.create ===
                    true ||
                  permissions === null
                ) {
                  setAddERPModal(true);
                  setDisplayModal(true);
                } else {
                  swal(
                    "Warning",
                    "You Don't have Access to Create Company ",
                    "warning"
                  );
                }
              }}
            />

            {companies.map((company, index) => {
              const colIndex = index % 5; // 0-based column index in 5-column layout

              // Define variation sets
              const leftToRightVariants = [
                { x: -120, y: -10, duration: 0.4 },
                { x: -100, y: 5, duration: 0.6 },
                { x: -150, y: 15, duration: 0.5 },
              ];

              const rightToLeftVariants = [
                { x: 120, y: -10, duration: 0.4 },
                { x: 100, y: 10, duration: 0.6 },
                { x: 140, y: 20, duration: 0.5 },
              ];

              const middleColumnVariants = [
                { x: -80, y: 0, duration: 0.5 },
                { x: 80, y: 0, duration: 0.5 },
                { x: 0, y: -100, duration: 0.6 },
                { x: 0, y: 100, duration: 0.4 },
                { x: -100, y: -100, duration: 0.7 },
              ];

              // Pick variant based on column
              let variant;
              if (colIndex <= 1) {
                variant =
                  leftToRightVariants[index % leftToRightVariants.length];
              } else if (colIndex >= 3) {
                variant =
                  rightToLeftVariants[index % rightToLeftVariants.length];
              } else {
                variant =
                  middleColumnVariants[index % middleColumnVariants.length];
              }
              return (
                <motion.span
                  key={company._id}
                  initial={{ x: variant.x, y: variant.y, opacity: 0 }}
                  animate={{ x: 0, y: 0, opacity: 1 }}
                  transition={{ duration: variant.duration, ease: "easeOut" }}
                  onClick={() => {
                    // showCompany(company);
                    handleClick(`/myfinV2/company-details/${company._id}`);
                  }}
                  className="clickable"
                >
                  <CompanyCard
                    leftImage={
                      company?.logo?.url ? (
                        <img src={company?.logo?.url} alt="Left" />
                      ) : (
                        <DefaultCompanyIcon width={60} height={80} />
                      )
                    }
                    rightIcon={<CurrencyWatermark currency={company.functional} />}
                    companyName={company.company_name}
                    tag={
                      company.nature_of_company && (
                        <StatusIndicator
                          status="red"
                          label={company.nature_of_company}
                        />
                      )
                    }
                    functionalCurrency={company.functional}
                    min={`${companyInfo != null ? true : false}`}
                  />
                </motion.span>
              );
            })}
          </div>
        </div>
        {companyInfo && !erpConnectionInfo && (
          <div className="edit-company-content info-content">
            <main>
              <header className="company-header">
                <span className="companyname-header">
                  {companyInfo.company_name}

                  <span>
                    <CloseIcon
                      className="close-company-info clickable"
                      onClick={() => {
                        setCompanyInfo(null);
                      }}
                    />
                  </span>
                </span>
                <hr className="hr-brcolor" />
                <div className="button-group"></div>
                <div className="header-actions"></div>
              </header>
              <div className="company-info-div">
                <span className="company-info-labels clickable">
                  <EditIcon
                    width={15}
                    height={15}
                    className="vaMiddle clickable"
                    onClick={() => {
                      setCompanyInfo(null);
                    }}
                  />
                  &ensp; Edit Company
                </span>
                <hr className="hr-brcolor hr-edit-separator" />
                <span
                  className="company-info-labels clickable"
                  onClick={() => {
                    showERPConnections(companyInfo);
                  }}
                >
                  <ConnectorIcon
                    width={15}
                    height={15}
                    className="vaMiddle clickable"
                  />
                  &ensp;Link to ERP
                </span>
                <hr className="hr-brcolor hr-edit-separator" />

                <span className="company-info-labels clickable">
                  <DocIcon
                    width={15}
                    height={15}
                    className="vaMiddle clickable"
                    onClick={() => {
                      setCompanyInfo(null);
                    }}
                  />
                  &ensp;Accounting Policies
                </span>
                <hr className="hr-brcolor hr-edit-separator" />
              </div>
            </main>
          </div>
        )}
        {erpConnectionInfo && (
          <div className="edit-company-content info-content">
            <main>
              <div className="company-header">
                <span className="companyname-header">
                  <LeftIcon
                    className="close-erp-info clickable"
                    onClick={() => {
                      setErpConnectionInfo(false);
                    }}
                  />
                  {companyInfo.company_name}
                  {linkErpBtn && (
                    <Button
                      btnColor={buttoncss.primary}
                      label="Add New ERP"
                      onClick={() => {
                        setAddERPModal(true);
                        setDisplayModal(true);
                      }}
                      class_={"add-erp-btn"}
                    />
                  )}
                </span>
                <hr className="hr-brcolor" />
              </div>
              {linkErpBtn && (
                // <div className="erp-info-div">
                <span className="companyname-header primaryColor">
                  No ERP Linked
                </span>
                // </div>
              )}

              {companyErp && companyErp === "DynamicBC" && (
                <>
                  <Tabs
                    class_={"erp-tabs"}
                    tabs={erpTabs}
                    activeTab={"MSBC"}
                    setActiveTab={setActiveTab}
                  />
                  <div className="erp-info-div">
                    <Dropdown
                      label="Linked ERP"
                      options={erps}
                      onSelect={(selected) => {
                        setSelectedERP(selected.value);
                        setCompanyErp(selected.value);
                      }}
                      placeHolder={"Select ERP"}
                      selected={{
                        label: "MSBC",
                        value: "msbc",
                      }}
                    />
                    <InputGroup
                      label="Company Name"
                      inputs={[
                        <>
                          <input
                            type="text"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                          />
                        </>,
                      ]}
                    />
                    <Dropdown
                      label="Connection Type"
                      options={[
                        {
                          label: "OAuth",
                          value: "OAuth",
                        },
                      ].map((connectiontype) => ({
                        label: connectiontype.label,
                        value: connectiontype.value,
                      }))}
                      onSelect={(value) => setConnectionType(value)}
                      placeHolder={"Connection Type"}
                      selected={{
                        label: connectionType,
                        value: connectionType,
                      }}
                    />
                    <InputGroup
                      label="OAuth URL"
                      inputs={[
                        <>
                          <textarea
                            value={oAuthUrl}
                            onChange={(e) => setOAuthUrl(e.target.value)}
                          />
                        </>,
                      ]}
                    />
                    <InputGroup
                      label="API Base URL"
                      inputs={[
                        <>
                          <textarea
                            value={apiBaseUrl}
                            onChange={(e) => setApiBaseUrl(e.target.value)}
                            rows={4}
                          />
                        </>,
                      ]}
                    />
                    <InputGroup
                      inputs={[
                        <>
                          <InputGroup
                            label="Tenent ID"
                            inputs={[
                              <>
                                <input
                                  type="text"
                                  value={tentId}
                                  onChange={(e) => setTentId(e.target.value)}
                                />
                              </>,
                            ]}
                          />
                        </>,
                        <>
                          <InputGroup
                            label="Client ID"
                            inputs={[
                              <>
                                <input
                                  type="text"
                                  value={clientId}
                                  onChange={(e) => setClientId(e.target.value)}
                                />
                              </>,
                            ]}
                          />
                        </>,
                      ]}
                    />
                    <InputGroup
                      inputs={[
                        <>
                          <InputGroup
                            label="Client Secret"
                            inputs={[
                              <>
                                <input
                                  type="text"
                                  value={clientSecret}
                                  onChange={(e) =>
                                    setClientSecret(e.target.value)
                                  }
                                />
                              </>,
                            ]}
                          />
                        </>,
                        <>
                          <InputGroup
                            label="Scope"
                            inputs={[
                              <>
                                <input
                                  type="text"
                                  value={scope}
                                  onChange={(e) => setScope(e.target.value)}
                                />
                              </>,
                            ]}
                          />
                        </>,
                      ]}
                    />
                    <Dropdown
                      label="Grant Type"
                      options={[
                        {
                          label: "client_credentials",
                          value: "client_credentials",
                        },
                      ].map((connectiontype) => ({
                        label: connectiontype.label,
                        value: connectiontype.value,
                      }))}
                      onSelect={(value) => setGrantType(value)}
                      placeHolder={"Grant Type"}
                      selected={{
                        label: grantType,
                        value: grantType,
                      }}
                    />
                    <ToggleButton
                      class_={`m_tb_20 ${commoncss.displayNone}`}
                      label=""
                      id="msbc"
                      value={linkStatus.msbc}
                      onToggle={handleLinkStatus}
                    />
                    <Button
                      btnColor={buttoncss.primary}
                      label="Save"
                      onClick={() => {
                        updateErpConfigData();
                      }}
                      class_={"save-creds-btn"}
                    />
                  </div>
                </>
              )}
              {companyErp && companyErp === "tallyPrime" && (
                <>
                  <Tabs
                    class_={"erp-tabs"}
                    tabs={erpTabs}
                    activeTab={"Tally Prime"}
                    setActiveTab={setActiveTab}
                  />
                  <div className="erp-info-div">
                    <Dropdown
                      label="Linked ERP"
                      options={erps}
                      onSelect={(selected) => {
                        setSelectedERP(selected.value);
                        setCompanyErp(selected.value);
                      }}
                      selected={{
                        label: "Tally Prime",
                        value: "tally_prime",
                      }}
                      placeHolder={"Select ERP"}
                    />
                    <InputGroup
                      label="Company Name"
                      inputs={[
                        <>
                          <input
                            type="text"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                          />
                        </>,
                      ]}
                    />
                    <InputGroup
                      inputs={[
                        <>
                          <InputGroup
                            label="API Base URL"
                            inputs={[
                              <>
                                <textarea
                                  value={apiBaseUrl}
                                  onChange={(e) =>
                                    setApiBaseUrl(e.target.value)
                                  }
                                  rows={4}
                                />
                              </>,
                            ]}
                          />
                        </>,
                      ]}
                    />
                    <ToggleButton
                      class_={`m_tb_20 ${commoncss.displayNone}`}
                      label=""
                      id="tally_prime"
                      value={linkStatus.tally_prime}
                      onToggle={handleLinkStatus}
                    />
                    <Button
                      btnColor={buttoncss.primary}
                      label="Save"
                      onClick={() => {
                        updateErpConfigData();
                      }}
                      class_={"save-creds-btn"}
                    />
                  </div>
                </>
              )}
            </main>
          </div>
        )}
        {addERPModal && displayModal && (
          <AddEditCompanyModal
            handleClose={handleClose}
            fetchCompanies={fetchCompanies}
            event="Create"
          />
        )}
        {successModal && displayModal && (
          <SuccessModal
            handleClose={handleClose}
            setSuccessModal={setSuccessModal}
            setSuccessMessage={setSuccessMessage}
            successMessage={successMessage}
          />
        )}

        {errorModal && displayModal && (
          <ErrorModal
            // handleClose={}
            setErrorModal={setErrorModal}
            setErrorMessage={setErrorMessage}
            errorMessage={errorMessage}
          />
        )}
      </div>
    </div>
  );
}
